"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var indexer_exports = {};
__export(indexer_exports, {
  Indexer: () => Indexer
});
module.exports = __toCommonJS(indexer_exports);
var Indexer;
((Indexer2) => {
  let Reindex;
  ((Reindex2) => {
    Reindex2.path = "indexer/reindex";
  })(Reindex = Indexer2.Reindex || (Indexer2.Reindex = {}));
})(Indexer || (Indexer = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Indexer
});
